<template>
  <el-container>
    <el-container style="margin-top: 55px">
      <el-aside class="padding-0">
        <div class="fixed overflow-auto" style="top: 55px; bottom: 0; width: 285px">
          <el-scrollbar>
            <AsideContainer />
          </el-scrollbar>
        </div>
      </el-aside>
      <el-main>
        <router-view />
        <div class="margin-top-40 text-center">
          <a
            href="http://www.beian.miit.gov.cn/"
            class="color-999 font-12"
            style="text-decoration: none"
            target="_blank"
            rel="noopener noreferrer"
            >ICP备案/许可证号：冀ICP备2021021396号-1</a
          >
        </div>
      </el-main>
    </el-container>
    <el-header>
      <div class="flex align-center justify-between margin-auto" style="width: 80%">
        <div class="logo-container">
          <a href="/" class="flex align-center"
            ><img class="logo" :src="require('@/assets/images/element-plus-logo.svg')" alt="Elemenet Plus Logo" /> Dark</a
          >
        </div>
        <div class="flex align-center">
          <el-color-picker v-if="isSkinOpen" v-model="darkBgColorBase" />
          <el-button v-show="isSkinOpen" type="primary" style="margin-left: 12px" @click="oneKeyChangeSkin"
            >一键换肤</el-button
          >
          <el-button v-show="isSkinOpen" plain @click="resetSkin">重置</el-button>
          <el-button plain @click="toggleSkin">{{ isSkinOpen ? '关闭' : '开启' }}暗黑模式</el-button>
        </div>
      </div>
    </el-header>
  </el-container>
  <el-backtop />
</template>

<script>
import AsideContainer from '@/views/layout/aside-container.vue';
const tinycolor = require('tinycolor2');
export default {
  components: {
    AsideContainer,
  },
  data() {
    return {
      darkBgColorBase: 'rgb(29, 59, 93)',
      isSkinOpen: true,
    };
  },
  methods: {
    setSkin() {
      if (!document.body.classList.contains('element-plus-dark')) {
        document.body.classList.add('element-plus-dark');
      }
      const rootStyle = document.body.style;
      rootStyle.setProperty('--dark-bg-color-base', this.darkBgColorBase);
      rootStyle.setProperty('--dark-bg-color-light-1', tinycolor(this.darkBgColorBase).lighten(5).toString());
      rootStyle.setProperty('--dark-bg-color-light-2', tinycolor(this.darkBgColorBase).lighten(10).toString());
      rootStyle.setProperty('--dark-bg-color-light-3', tinycolor(this.darkBgColorBase).lighten(15).toString());
      rootStyle.setProperty('--dark-bg-color-dark', tinycolor(this.darkBgColorBase).darken(5).toString());
      rootStyle.setProperty('$dark-bg-color-base-alpha', tinycolor(this.darkBgColorBase).setAlpha(0.1).toString());

      rootStyle.setProperty('--el-bg-color', tinycolor(this.darkBgColorBase).lighten(10).toString());

      rootStyle.setProperty('--el-text-color-disabled-base', tinycolor.mix(this.darkBgColorBase, '#fff', 80).toString());

      rootStyle.setProperty('--el-text-color-primary', tinycolor.mix(this.darkBgColorBase, '#fff', 98).toString());
      rootStyle.setProperty('--el-text-color-regular', tinycolor.mix(this.darkBgColorBase, '#fff', 95).toString());
      rootStyle.setProperty('--el-text-color-secondary', tinycolor.mix(this.darkBgColorBase, '#fff', 90).toString());
      rootStyle.setProperty('--el-text-color-placeholder', tinycolor.mix(this.darkBgColorBase, '#fff', 85).toString());

      rootStyle.setProperty('--el-border-color-base', tinycolor.mix(this.darkBgColorBase, '#fff', 50).toString());
      rootStyle.setProperty('--el-border-color-light', tinycolor.mix(this.darkBgColorBase, '#fff', 45).toString());
      rootStyle.setProperty('--el-border-color-lighter', tinycolor.mix(this.darkBgColorBase, '#fff', 40).toString());
      rootStyle.setProperty('--el-border-color-extra-light', tinycolor.mix(this.darkBgColorBase, '#fff', 35).toString());

      rootStyle.setProperty('--el-disabled-bg-color', tinycolor(this.darkBgColorBase).darken(5).toString());
    },
    oneKeyChangeSkin() {
      this.setSkin();
    },
    resetSkin() {
      this.darkBgColorBase = 'rgb(29, 59, 93)';
      this.setSkin();
    },
    toggleSkin() {
      if (this.isSkinOpen) {
        document.body.removeAttribute('style');
      } else {
        this.darkBgColorBase = 'rgb(29, 59, 93)';
      }
      this.isSkinOpen = !this.isSkinOpen;
      document.body.classList.toggle('element-plus-dark');
    },
  },
};
</script>

<style lang="scss">
// @import 'element-plus-dark/index.scss';
@import '@/assets/dark-mode/index.scss';
@import 'construct-scss/css/construct-pc.css';

body {
  margin: 0;
  background-image: linear-gradient(
    to right,
    var(--dark-bg-color-base) 0%,
    var(--dark-bg-color-base) 80%,
    var(--dark-bg-color-light-1) 100%
  );
}

#app {
  width: 80%;
  min-width: 1400px;
  margin: 0 auto;
}

/**
 * header
 */

.el-header {
  --el-header-height: 54px !important;
  border-bottom: 1px solid var(--dark-bg-color-light-3, #eee);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background-color: var(--dark-bg-color-base, #f6f6f6);

  .logo-container {
    display: flex;
    align-items: center;
    height: var(--el-header-height);
    font-size: 20px;
    color: #409eff;

    .logo {
      display: block;
      width: 128px;
      height: 28px;
    }

    a {
      text-decoration: none;
      color: #409eff;
    }
  }
}

.el-main {
  padding-bottom: 40px;
  min-height: calc(100vh - 55px);

  h1 {
    font-size: 36px;
  }

  p {
    line-height: 1.8;
    font-size: var(--el-font-size-base);
    font-size: 16px;
  }

  .inline-code {
    border-color: var(--dark-bg-color-light-1, #eee) !important;
    background-color: var(--dark-bg-color-light-1, #f6f6f6) !important;
    font-size: 14px !important;
    line-height: var(--el-font-line-height-primary) !important;
    color: var(--el-text-color-primary) !important;
  }

  pre {
    background-color: var(--dark-bg-color-light-1, #eee);
    padding: 20px;
    line-height: 1.8;
  }
}
</style>
